import script from "./StudentCourseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentCourseModal.vue?vue&type=script&setup=true&lang=js"

import "./StudentCourseModal.vue?vue&type=style&index=0&id=c076615e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c076615e"]])

export default __exports__